
         
<template>
          
          

  <div class="col-md-6 mt-4"  v-for="rol in paginatedroller" :key="rol.id" >
        <div class="card h-100">
       
          <div class="card-body">
            <h5>{{ rol.ad }} </h5>
            <div class="text-muted mb-3">{{ rol.aciklama }}</div>
            <template v-for="yetki in yetkiler" :key="yetki.key">
              <div class="mb-1" v-if="rol.yetkiler.includes(yetki.key)">{{yetki.ad}}</div>
              <div class="text-muted mb-1">
                {{ (rol.yetkiler.includes(yetki.key+'_goster')) ? ' Görüntüleyebilir' : ''  }}
                {{ (rol.yetkiler.includes(yetki.key+'_ekle')) ? ' Ekleyebilir' : ''  }}
                {{ (rol.yetkiler.includes(yetki.key+'_duzenle')) ? ' Düzenleyebilir' : ''  }}
                {{ (rol.yetkiler.includes(yetki.key+'_sil')) ? ' Silebilir' : ''  }}
              </div>
          </template>
            
            <div class="mt-4 text-center">
            
    <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('rol_duzenle')" @click="duzenle(rol)">
        <em class="icon ni ni-pen"></em>
      </a>
    
 
      <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('rol_sil')" @click="sil(rol.id)">
        <em class="icon ni ni-trash-alt"></em>
      </a>
            </div>
          </div>
        </div>
      </div>

      <div class="card-inner">
<div class="nk-block-between-md g-3">
  <div class="g">
    <ul class="pagination justify-content-center justify-content-md-start">
      <li :class="{ active: page === roller.seciliSayfa, 'page-item': true }" v-for="page in pages"
        :key="page">
        <a class="page-link" href="#" @click="rollerSayfaDegistir(page)">{{ page }}</a>
      </li>

    </ul>
  </div>

</div>
</div>




</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
props: {

roller:{
type: Array,
required: true
},
duzenle: Function,
detay: Function,
formKaydetSonrasi: Function,
tur:String,
},
data() {
return {


yetkiler: [
            { key: 'kullanici', ad: 'Kullanıcılar' },
            { key: 'rol', ad: 'Roller' },
            { key: 'firma', ad: 'Firmalar' },
            { key: 'depertman', ad: 'Departmanlar' },
            { key: 'etkinlik', ad: 'Etkinlikler' },
            { key: 'kisi', ad: 'Kişiler' },
            { key: 'gorusmebilgi', ad: 'Görüşme Bilgileri' }, 
],

};
},
computed: {
filteredroller() {
// Arama filtresine göre kullanıcıları filtrele
return this.roller.tumu.filter(
(rol) =>

  rol.ad.toLowerCase() 
  
  .includes(this.roller.arananKelime.toLowerCase()) ||rol.ad.toLowerCase()
  
  
  .includes(this.roller.arananKelime.toLowerCase()) ||rol.aciklama.toLowerCase()
  
  .includes(this.roller.arananKelime.toLowerCase()) ||rol.yetkiler.toLowerCase()
  
  .includes(this.roller.arananKelime.toLowerCase())



);
},
paginatedroller() {
const start = (this.roller.seciliSayfa - 1) * this.roller.sayfadaKayit;
const end = start + this.roller.sayfadaKayit;
return this.filteredroller.slice(start, end);
},
roller_toplamSayfa() {
const totalFilteredUsers = this.filteredroller.length;
const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.roller.sayfadaKayit), 1);
if (this.roller.seciliSayfa > maxPage) {
this.rollerSayfaDegistir(maxPage);
}
return maxPage;
},
pages() {
const totalPageCount = this.roller_toplamSayfa;
const maxVisiblePages = 5;
const currentPage = this.roller.seciliSayfa;

if (totalPageCount <= maxVisiblePages) {
    return Array.from({ length: totalPageCount }, (_, index) => index + 1);
}

const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
},

},
methods: {
yetki_kontrol(yetki){
return yetkiKontrol(yetki);
},
async sil(rolId) {
const result = await this.$swal({
title: "Emin misiniz?",
text: "Bu işlemi geri alamayacaksınız!",
icon: "warning",
showCancelButton: true,
confirmButtonColor: "#3085d6",
cancelButtonColor: "#d33",
confirmButtonText: "Evet, sil!",
cancelButtonText: "İptal",
});

if (result.isConfirmed) {
try {
  await axiosCustom.post("roller/sil/" + rolId);
  this.$toast.success("Kayıt Silindi");
  this.formKaydetSonrasi();
} catch (error) {
  console.error("Silme hatası: ", error);
  this.$toast.error("Silme hatası");
}
}
},
rollerSayfaDegistir(page) {
this.$emit('update:roller',{
...this.roller,
seciliSayfa: page
});
},
rollerSayfadaKayitDegistir(value) {
this.$emit('update:roller',{
...this.roller,
sayfadaKayit: value
});
this.rollerSayfaDegistir(1);
},
},
};
</script>
